export default "__VITE_ASSET__8c58570e__"